import React, { useState, useEffect } from "react";
import "./Ipad.css";

const Ipad = ({ theme }) => {
  const [powerVar, setPowerVar] = useState(1);

  useEffect(() => {
    if (theme === "light_theme") {
      setTimeout(() => {
        document.getElementsByClassName("ipadScreen")[0].style.opacity = 1;
      }, 1000);
    }
  }, []);

  const powerMe = () => {
    const inAppBar = document.getElementById("inAppBar");
    const wallpaper = document.getElementsByClassName("wallpaper")[0];
    const ipadScreen = document.getElementsByClassName("ipadScreen")[0];
    const lockScreen = document.getElementsByClassName("lockScreen")[0];
    const dockWrapper = document.getElementsByClassName("dockWrapper")[0];

    inAppBar.style.bottom = "-8%";
    inAppBar.style.pointerEvents = "none";
    wallpaper.style.backgroundImage =
      "url('https://assets.codepen.io/2722301/bg.jpg')";

    if (powerVar === 1) {
      ipadScreen.style.opacity = 1;
      ipadScreen.style.pointerEvents = "all";
      setPowerVar(0);

      lockScreen.style.transition =
        "top 800ms ease-in 0s, backdrop-filter 200ms ease-in 0s";
      dockWrapper.style.transition = "bottom 400ms ease-in-out 0s";
    } else {
      ipadScreen.style.opacity = 0;
      ipadScreen.style.pointerEvents = "none";
      setPowerVar(1);

      setTimeout(() => {
        lockScreen.style.transition = "none";
        dockWrapper.style.transition = "none";
        lockScreen.style.backdropFilter = "blur(0)";
        lockScreen.style.top = "0";
        dockWrapper.style.bottom = "-20%";
      }, 300);
    }

    resetIcons();
  };

  useEffect(() => {
    if (theme !== "light_theme") {
      powerMe();
    }
  }, []);

  const lockClick = () => {
    const lockScreen = document.getElementsByClassName("lockScreen")[0];
    const dockWrapper = document.getElementsByClassName("dockWrapper")[0];

    lockScreen.style.backdropFilter = "blur(2vh) brightness(1.2)";
    lockScreen.style.top = "-110%";
    dockWrapper.style.bottom = "3%";
  };

  const checkTime = () => {
    const day = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date();
    let minTime = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();

    document.getElementsByClassName("lockTime")[0].innerHTML =
      `${d.getHours()}:${minTime}<br/>` +
      `${day[d.getDay()]}, ${month[d.getMonth()]} ${d.getDate()}`;

    setTimeout(checkTime, 500);
  };

  useEffect(() => {
    if (theme === "light_theme") {
      checkTime();
    }
  }, []);

  const goHome = () => {
    const inAppBar = document.getElementById("inAppBar");
    const wallpaper = document.getElementsByClassName("wallpaper")[0];
    const dockWrapper = document.getElementsByClassName("dockWrapper")[0];

    inAppBar.style.bottom = "-8%";
    inAppBar.style.pointerEvents = "none";
    wallpaper.style.backgroundImage =
      "url('https://assets.codepen.io/2722301/bg.jpg')";
    dockWrapper.style.bottom = "3%";

    resetIcons();
  };

  const resetIcons = () => {
    window.lastIcon = false;
    const x = document.getElementsByClassName("iconDiv");
    for (let i = 0; i < x.length; i++) {
      x[i].style.width = "calc(var(--sizeVar) / 20)";
      x[i].style.height = "calc(var(--sizeVar) / 20)";
      x[i].style.margin =
        "calc(var(--sizeVar) / 60) calc(var(--sizeVar) / 120)";
      x[i].style.pointerEvents = "all";
      x[i].getElementsByClassName("imgDiv")[0].style.opacity = 0;
      if (powerVar === 1) {
        x[i].style.transition =
          "all 0s ease-in-out 350ms, transform 100ms ease-in-out 0s";
        x[i].getElementsByClassName("imgDiv")[0].style.transition =
          "opacity 0s linear 350ms";
      } else {
        x[i].style.transition =
          "all 500ms ease-in-out 0s, transform 100ms ease-in-out 0s";
        x[i].getElementsByClassName("imgDiv")[0].style.transition =
          "opacity 300ms linear 0s";
      }
    }
  };

  const iconClick = (e) => {
    const x = document.getElementsByClassName("iconDiv");
    for (let i = 0; i < x.length; i++) {
      x[i].style.width = 0;
      x[i].style.height = 0;
      x[i].style.margin = 0;
      x[i].style.pointerEvents = "none";
      x[i].getElementsByClassName("imgDiv")[0].style.opacity = 0;
    }

    if (window.lastIcon) {
      e.target.style.width = "calc(var(--sizeVar) * 1)";
    } else {
      e.target.style.width = "calc(var(--sizeVar) * .96)";
    }

    e.target.style.height = "calc(var(--sizeVar) * .74)";
    e.target.style.marginLeft = "calc(var(--sizeVar) / 35)";
    document.getElementsByClassName("dockWrapper")[0].style.bottom = 0;
    e.target.getElementsByClassName("imgDiv")[0].style.opacity = 1;
    document
      .getElementById("inAppBar")
      .style.setProperty("--colorMe", window.barColor);
    document.getElementById("inAppBar").style.bottom = "0";
    document.getElementById("inAppBar").style.pointerEvents = "all";

    setTimeout(() => {
      document.getElementsByClassName("wallpaper")[0].style.backgroundImage =
        "none";
    }, 500);
  };

  const iconFClick = (e) => {
    window.lastIcon = true;
    iconClick(e);
  };

  return (
    <div className="ipadBox">
      <button className="powerButton" onClick={powerMe}>
        I
      </button>
      <div className="ipadScreen">
        <div className="wallpaper">
          <div className="statusBar"></div>
          <div className="dockWrapper">
            <div className="dockbar">
              <div
                className="iconDiv"
                onClick={(event) => {
                  window.barColor = "white";
                  iconClick(event);
                }}
              >
                <div className="imgDiv"></div>
              </div>
              <div
                className="iconDiv"
                onClick={(event) => {
                  window.barColor = "white";
                  iconClick(event);
                }}
              >
                <div className="imgDiv"></div>
              </div>
              <div
                className="iconDiv"
                onClick={(event) => {
                  window.barColor = "white";
                  iconClick(event);
                }}
              >
                <div className="imgDiv"></div>
              </div>
              <div className="iconDivide"></div>
              <div
                className="iconDiv"
                onClick={(event) => {
                  window.barColor = "white";
                  iconFClick(event);
                }}
              >
                <div className="imgDiv"></div>
              </div>
              <div
                className="iconDiv"
                onClick={(event) => {
                  window.barColor = "white";
                  iconFClick(event);
                }}
              >
                <div className="imgDiv"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="lockScreen" onClick={lockClick}>
          <div className="lockContent">
            <div className="statusBar"></div>
            <div className="lockIcon"></div>
            <div className="lockTime">
              9:41
              <br />
              Saturday, August 17
            </div>
          </div>
          <div className="interactionBar"></div>
        </div>
        <div className="interactionBar" id="inAppBar" onClick={goHome}></div>
      </div>
    </div>
  );
};

export default Ipad;
